import { render, staticRenderFns } from "./i18n-page.vue?vue&type=template&id=3c738202&"
import script from "./i18n-page.vue?vue&type=script&lang=js&"
export * from "./i18n-page.vue?vue&type=script&lang=js&"
import style0 from "./i18n-page.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports